module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/banner-005177210498a120a8ec23de35abaa08.png";